// extracted by mini-css-extract-plugin
export default {"label":"EditRuleValidation_label__5xhaC","switcher":"EditRuleValidation_switcher__S1zr6","description":"EditRuleValidation_description__rll4d"};